// RSSB Palia Kalan Area — master data (25 Satsang Ghars, 62 Pathis, 32 SR/SK preachers)
// Personnel lists verified against official Excel lists provided by Area Secretary (June 2026).
// Names stored in both English and Hindi (Unicode Devanagari).

export const AREA_INFO = {
  areaHi: "पलिया कलां",
  orgHi: "राधा स्वामी सत्संग ब्यास",
  secretaryHi: "",
  secretaryNameHi: "श्री कपिल छाबड़ा",
  secretaryDesignationHi: "एरिया सेक्रेटरी, पलिया कलां",
  phones: "मोः 9760112220; 8979822222",
  leavePhones: "9927042368/9910289615",
  infoContactHi: "सुखजिंदर सिंह जी को 9910289615",
  timingHi:
    "सत्संग समयः रविवार सुबह 09:30 बजे, बुधवार सुबह 08:30 बजे शाम 04:30 बजे, गुरुवार सुबह 08:30 बजे शाम 04:30 बजे",
};

export const GROUPS = {
  1: "पलिया कलां क्षेत्र (Palia Kalan Area)",
  2: "मझरा पश्चिम क्षेत्र (Majhra Paschim Area)",
  3: "भीरा क्षेत्र (Bheera Area)",
  4: "राघवपुरी क्षेत्र (Raghavpuri Area)",
  5: "मलूकापुर क्षेत्र (Malookapur Area)",
  6: "खैरटिया क्षेत्र (Khairtiya Area)",
  7: "बनकटी क्षेत्र (Bankati Area)",
  8: "तातारगंज क्षेत्र (Tatarganj Area)",
};

// type: C = Center, SC = Sub-Center, SP = Sub-Point
// days: which weekdays hold satsang. 0=Sun,3=Wed,4=Thu
export const GHARS = [
  { id: "g1", en: "Palia Kalan", hi: "पलिया कलां", type: "C", group: 1, days: [0, 4] },
  { id: "g2", en: "Durgapurwa", hi: "दुर्गापुरवा", type: "SC", group: 1, days: [0] },
  { id: "g3", en: "Gaziapur", hi: "गजियापुर", type: "SC", group: 1, days: [0] },
  { id: "g4", en: "Nainapur", hi: "नैनापुर", type: "SC", group: 1, days: [0] },
  { id: "g5", en: "Dhakherwa Chauraha", hi: "ढकरवा", type: "SC", group: 1, days: [0] },
  { id: "g6", en: "Majhra Paschim", hi: "माझरा पश्चिम", type: "C", group: 2, days: [0] },
  { id: "g7", en: "Bamnagar", hi: "बामनगर", type: "SC", group: 2, days: [0] },
  { id: "g8", en: "Bheera", hi: "भीरा", type: "C", group: 3, days: [0] },
  { id: "g9", en: "Patti Patwara", hi: "पटटी पटवारा", type: "SP", group: 3, days: [0] },
  { id: "g10", en: "Raghavpuri", hi: "राघवपुरी", type: "C", group: 4, days: [0] },
  { id: "g11", en: "Gandhi Nagar", hi: "गांधी नगर", type: "SP", group: 4, days: [0] },
  { id: "g12", en: "Malookapur", hi: "मलूकापुर", type: "C", group: 5, days: [0] },
  { id: "g13", en: "Lakhimpur Kheri", hi: "लखीमपुर खीरी", type: "SC", group: 5, days: [0, 4] },
  { id: "g14", en: "Pakariya", hi: "पकरिया", type: "SP", group: 5, days: [0] },
  { id: "g15", en: "Hardi Majra", hi: "हरदी माझरा", type: "SC", group: 5, days: [0] },
  { id: "g16", en: "Khairtiya", hi: "खैरटिया", type: "C", group: 6, days: [0] },
  { id: "g17", en: "Singha Kalan", hi: "सिंघा कलां", type: "SP", group: 6, days: [0] },
  { id: "g18", en: "Tikunia", hi: "टिकोनिया", type: "SC", group: 6, days: [0] },
  { id: "g19", en: "Kadia", hi: "कड़िया", type: "SP", group: 6, days: [0] },
  { id: "g20", en: "Chapariya Bazar", hi: "चपरिया बाजार", type: "SP", group: 6, days: [0] },
  { id: "g21", en: "Bankati", hi: "बनकटी", type: "C", group: 7, days: [0, 3] },
  { id: "g22", en: "Chandan Chauki", hi: "चंदन चौकी", type: "SC", group: 7, days: [0, 4] },
  { id: "g23", en: "Devrahi", hi: "देवरही", type: "SP", group: 7, days: [0] },
  { id: "g24", en: "Barbata", hi: "बरबटा", type: "SP", group: 7, days: [0] },
  { id: "g25", en: "Tatarganj", hi: "टाटरगंज", type: "C", group: 8, days: [0] },
];

// 62 Pathis — all Grade A (per official "List of Pathis" Excel)
export const PATHIS = [
  { id: "p1", en: "Khushi Ram", hi: "खुशी राम", placeHi: "नैनापुर", group: 1, mobile: "9936111905" },
  { id: "p2", en: "Ritu Jhanjhi", hi: "रितु झांझी", placeHi: "पलिया कलां", group: 1, mobile: "8957171739" },
  { id: "p3", en: "Manohar Lal", hi: "मनोहर लाल", placeHi: "पलिया कलां", group: 1, mobile: "9984277001" },
  { id: "p4", en: "Pinki Devi", hi: "पिंकी देवी", placeHi: "दुर्गापुरवा", group: 1, mobile: "8810967434" },
  { id: "p5", en: "Hardayal", hi: "हरदयाल", placeHi: "पलिया कलां", group: 1, mobile: "8887812700" },
  { id: "p6", en: "Shripal", hi: "श्रीपाल", placeHi: "पलिया कलां", group: 1, mobile: "9415558413" },
  { id: "p7", en: "Ram Manohar", hi: "राम मनोहर", placeHi: "ढकेरवा", group: 1, mobile: "9565962601" },
  { id: "p8", en: "Ramdulare", hi: "रामदुलारे", placeHi: "गजियापुर", group: 1, mobile: "6307817873" },
  { id: "p9", en: "Renu Maurya-NN", hi: "रेनू मौर्या (नैनापुर)", placeHi: "नैनापुर", group: 1, mobile: "8960554371" },
  { id: "p10", en: "Sunita Verma", hi: "सुनीता वर्मा", placeHi: "पलिया कलां", group: 1, mobile: "9450467044" },
  { id: "p11", en: "Daya Shankar", hi: "दया शंकर", placeHi: "ढकेरवा", group: 1, mobile: "7380631383" },
  { id: "p12", en: "Chandra Sen", hi: "चंद्र सेन", placeHi: "पलिया कलां", group: 1, mobile: "8726961787" },
  { id: "p13", en: "Neelam Maurya", hi: "नीलम मौर्या", placeHi: "दुर्गापुरवा", group: 1, mobile: "9565623571" },
  { id: "p14", en: "Laxmi", hi: "लक्ष्मी", placeHi: "ढकेरवा", group: 1, mobile: "9580060961" },
  { id: "p15", en: "Harpal", hi: "हरपाल", placeHi: "बमनगर", group: 2, mobile: "8840353428" },
  { id: "p16", en: "Parshuram", hi: "परशुराम", placeHi: "बमनगर", group: 2, mobile: "9305062771" },
  { id: "p17", en: "Ram Ashish", hi: "राम आशीष", placeHi: "मझरा पश्चिम", group: 2, mobile: "7068175116" },
  { id: "p18", en: "Shobhavati", hi: "शोभावती", placeHi: "मझरा पश्चिम", group: 2, mobile: "9415558413" },
  { id: "p19", en: "Tripta", hi: "तृप्ता", placeHi: "मझरा पश्चिम", group: 2, mobile: "7880485529" },
  { id: "p21", en: "Susheela Devi-1", hi: "सुशीला देवी-1", placeHi: "भीरा", group: 3, mobile: "6386235179" },
  { id: "p22", en: "Susheela W/O Raju", hi: "सुशीला (राजू)", placeHi: "भीरा", group: 3, mobile: "8400815594" },
  { id: "p23", en: "Jagdish", hi: "जगदीश", placeHi: "पट्टी पटवारा", group: 3, mobile: "8004541347" },
  { id: "p24", en: "Kulwant Kaur", hi: "कुलवंत कौर", placeHi: "राघवपुरी", group: 4, mobile: "9120050742" },
  { id: "p25", en: "Harbans Singh", hi: "हरबंस सिंह", placeHi: "राघवपुरी", group: 4, mobile: "9519162674" },
  { id: "p26", en: "Raj Kaur", hi: "राज कौर", placeHi: "राघवपुरी", group: 4, mobile: "7579849042" },
  { id: "p27", en: "Sadhna Devi", hi: "साधना देवी", placeHi: "राघवपुरी", group: 4, mobile: "7839816537" },
  { id: "p28", en: "Subeg Singh", hi: "सुबेग सिंह", placeHi: "राघवपुरी", group: 4, mobile: "7376851072" },
  { id: "p29", en: "Jaggu Prasad", hi: "जग्गू प्रसाद", placeHi: "गांधी नगर", group: 4, mobile: "7670160446" },
  { id: "p30", en: "Niraj Devi", hi: "नीरज देवी", placeHi: "गांधी नगर", group: 4, mobile: "7607935126" },
  { id: "p31", en: "Kamal Kishore", hi: "कमल किशोर", placeHi: "पकरिया", group: 5, mobile: "8874319914" },
  { id: "p32", en: "Ramu Maurya", hi: "रामू मौर्या", placeHi: "हरदी मजरा", group: 5, mobile: "9120873537" },
  { id: "p33", en: "Renu Maurya-LK", hi: "रेनू मौर्या (लखीमपुर)", placeHi: "लखीमपुर", group: 5, mobile: "9451067529" },
  { id: "p34", en: "Renu Wadhawan", hi: "रेनू वधावन", placeHi: "लखीमपुर", group: 5, mobile: "8127050635" },
  { id: "p35", en: "Sarita Agarwal", hi: "सरिता अग्रवाल", placeHi: "लखीमपुर", group: 5, mobile: "7355105620" },
  { id: "p36", en: "Surinder Pal", hi: "सुरिंदर पाल", placeHi: "लखीमपुर", group: 5, mobile: "9415460924" },
  { id: "p37", en: "Surjit Kaur", hi: "सुरजीत कौर", placeHi: "लखीमपुर", group: 5, mobile: "9161269602" },
  { id: "p38", en: "Uttam Kumar", hi: "उत्तम कुमार", placeHi: "मलूकापुर", group: 5, mobile: "81760609644" },
  { id: "p39", en: "Omkar", hi: "ओमकार", placeHi: "पकरिया", group: 5, mobile: "9919479628" },
  { id: "p40", en: "Bageej Singh", hi: "बगीज सिंह", placeHi: "खैरटिया", group: 6, mobile: "8303759256" },
  { id: "p41", en: "Vijay Kumar", hi: "विजय कुमार", placeHi: "चपरिया बाजार", group: 6, mobile: "9919575422" },
  { id: "p42", en: "Ramkumari", hi: "रामकुमारी", placeHi: "चपरिया बाजार", group: 6, mobile: "9569131323" },
  { id: "p43", en: "Dharampal", hi: "धरमपाल", placeHi: "देवरही", group: 7, mobile: "9451519134" },
  { id: "p44", en: "Dhokeram", hi: "धोकेराम", placeHi: "बरबटा", group: 7, mobile: "7355557845" },
  { id: "p45", en: "Dhanna Ram", hi: "धन्ना राम", placeHi: "बरबटा", group: 7, mobile: "8881405556" },
  { id: "p46", en: "Bahale Ram", hi: "बहाले राम", placeHi: "बनकटी", group: 7, mobile: "9219477875" },
  { id: "p47", en: "Baliram", hi: "बलिराम", placeHi: "बनकटी", group: 7, mobile: "9236863783" },
  { id: "p48", en: "Kamla Devi", hi: "कमला देवी", placeHi: "चंदन चौकी", group: 7, mobile: "9453269548" },
  { id: "p49", en: "Kalavati", hi: "कलावती", placeHi: "बरबटा", group: 7, mobile: "9140265826" },
  { id: "p50", en: "Manju Rana", hi: "मंजू राना", placeHi: "बनकटी", group: 7, mobile: "9454562148" },
  { id: "p51", en: "Melaram", hi: "मेलाराम", placeHi: "देवरही", group: 7, mobile: "9453197844" },
  { id: "p52", en: "Shivrani", hi: "शिवरानी", placeHi: "चंदन चौकी", group: 7, mobile: "9455613932" },
  { id: "p53", en: "Sittha Devi", hi: "सित्था देवी", placeHi: "देवरही", group: 7, mobile: "7307672953" },
  { id: "p54", en: "Pyaare Lal", hi: "प्यारे लाल", placeHi: "चंदन चौकी", group: 7, mobile: "6394650218" },
  { id: "p55", en: "Ranjana", hi: "रंजना", placeHi: "चंदन चौकी", group: 7, mobile: "9532092534" },
  { id: "p56", en: "Srikrishan", hi: "श्रीकृष्ण", placeHi: "चंदन चौकी", group: 7, mobile: "7376683003" },
  { id: "p57", en: "Ramphool", hi: "रामफूल", placeHi: "बनकटी", group: 7, mobile: "9454862408" },
  { id: "p58", en: "Somvati", hi: "सोमवती", placeHi: "चंदन चौकी", group: 7, mobile: "8273381239" },
  { id: "p59", en: "Dataram", hi: "दत्ताराम", placeHi: "बनकटी", group: 7, mobile: "9817630846" },
  { id: "p60", en: "Anita", hi: "अनीता", placeHi: "बनकटी", group: 7, mobile: "6307970513" },
  { id: "p61", en: "Rajendra Singh", hi: "राजेंद्र सिंह", placeHi: "टाटरगंज", group: 8, mobile: "8081560084" },
  { id: "p62", en: "Jeet Singh", hi: "जीत सिंह", placeHi: "टाटरगंज", group: 8, mobile: "7897696834" },
];

// 32 SR / SK preachers (per official "List of SK/SR/BSK/ZSK" Excel)
export const PREACHERS = [
  { id: "s1", en: "Balakram Verma", hi: "बालकराम वर्मा", role: "SR", placeHi: "ढकेरवा", group: 1, mobile: "7379605033" },
  { id: "s2", en: "Madhuri Maurya", hi: "माधुरी मौर्या", role: "SR", placeHi: "दुर्गापुरवा", group: 1, mobile: "6373254727" },
  { id: "s3", en: "Hemlata Verma", hi: "हेमलता वर्मा", role: "SR", placeHi: "पलिया कलां", group: 1, mobile: "9555714710" },
  { id: "s4", en: "Ramcharan Maurya", hi: "रामचरन मौर्या", role: "SR", placeHi: "दुर्गापुरवा", group: 1, mobile: "8318600536" },
  { id: "s5", en: "Ram Gopal", hi: "राम गोपाल", role: "SR", placeHi: "दुर्गापुरवा", group: 1, mobile: "8052169407" },
  { id: "s6", en: "Rameshwar Dayal", hi: "रामेश्वर दयाल", role: "SR", placeHi: "गजियापुर", group: 1, mobile: "9628971816" },
  { id: "s7", en: "Ramjit", hi: "रामजीत", role: "SR", placeHi: "दुर्गापुरवा", group: 1, mobile: "8052169407" },
  { id: "s8", en: "Swadesh Kumar", hi: "स्वदेश कुमार", role: "SR", placeHi: "पलिया कलां", group: 1, mobile: "7905662985" },
  { id: "s9", en: "Tejnarayan", hi: "तेजनारायण", role: "SR", placeHi: "नैनापुर", group: 1, mobile: "9918930744" },
  { id: "s10", en: "Indira Srivastava", hi: "इंदिरा श्रीवास्तव", role: "SK", placeHi: "पलिया कलां", group: 1, mobile: "8299462803" },
  { id: "s11", en: "Gouri Shankar Yadav", hi: "गौरी शंकर यादव", role: "SR", placeHi: "पलिया कलां", group: 1, mobile: "8173003233" },
  { id: "s12", en: "Subhash Sharma", hi: "सुभाष शर्मा", role: "SR", placeHi: "मझरा पश्चिम", group: 2, mobile: "7897410863" },
  { id: "s13", en: "Mewa Lal", hi: "मेवा लाल", role: "SR", placeHi: "पकरिया", group: 5, mobile: "6306810949" },
  { id: "s14", en: "Dinesh Kumar", hi: "दिनेश कुमार", role: "SR", placeHi: "लखीमपुर", group: 5, mobile: "9936409006" },
  { id: "s15", en: "Parveen Gulati", hi: "परवीन गुलाटी", role: "SR", placeHi: "लखीमपुर", group: 5, mobile: "9236041633" },
  { id: "s16", en: "Ramji Gupta", hi: "रामजी गुप्ता", role: "SR", placeHi: "लखीमपुर", group: 5, mobile: "9305424360" },
  { id: "s17", en: "Sukhdev Raj", hi: "सुखदेव राज", role: "SR", placeHi: "मलूकापुर", group: 5, mobile: "9919238383" },
  { id: "s18", en: "Sewa Singh", hi: "सेवा सिंह", role: "SK", placeHi: "मलूकापुर", group: 5, mobile: "9628872047" },
  { id: "s19", en: "Kashmir Singh", hi: "कश्मीर सिंह", role: "SR", placeHi: "खैरटिया", group: 6, mobile: "7460032306" },
  { id: "s20", en: "Bandevi", hi: "बानदेवी", role: "SR", placeHi: "देवरही", group: 7, mobile: "6392485669" },
  { id: "s21", en: "Bihari Lal", hi: "बिहारी लाल", role: "SR", placeHi: "बनकटी", group: 7, mobile: "6394577544" },
  { id: "s22", en: "Bharat Singh", hi: "भरत सिंह", role: "SR", placeHi: "बरबटा", group: 7, mobile: "9837750124" },
  { id: "s23", en: "Premrati", hi: "प्रेमरति", role: "SR", placeHi: "बनकटी", group: 7, mobile: "6392402753" },
  { id: "s24", en: "Rajeshwari Gupta", hi: "राजेश्वरी गुप्ता", role: "SR", placeHi: "चंदन चौकी", group: 7, mobile: "6386067291" },
  { id: "s25", en: "Sharda Prasad", hi: "शारदा प्रसाद", role: "SR", placeHi: "बनकटी", group: 7, mobile: "7380895112" },
  { id: "s26", en: "Jagdish-D", hi: "जगदीश (देवरही)", role: "SR", placeHi: "देवरही", group: 7, mobile: "9219095948" },
  { id: "s27", en: "Kulvinder Singh", hi: "कुलविंदर सिंह", role: "SR", placeHi: "तातारगंज", group: 8, mobile: "7668755624" },
  { id: "s28", en: "Satnam Singh", hi: "सतनाम सिंह", role: "SR", placeHi: "तातारगंज", group: 8, mobile: "9555361834" },
  { id: "s29", en: "Lalta Singh", hi: "लालता सिंह", role: "SR", placeHi: "लखीमपुर", group: 5, mobile: "9721950651" },
  { id: "s30", en: "Harjeet Singh", hi: "हरजीत सिंह", role: "SR", placeHi: "दुर्गापुरवा", group: 1, mobile: "8726660058" },
  { id: "s31", en: "Ram Swaroop", hi: "रामस्वरूप", role: "SR", placeHi: "सिंघा कलां", group: 6, mobile: "7379419392" },
  { id: "s32", en: "Jawahar", hi: "जवाहर", role: "SR", placeHi: "बरबटा", group: 7, mobile: "8467945845" },
  { id: "s33", en: "Sita Devi", hi: "सीता देवी", role: "SR", title: "श्रीमती", placeHi: "भीरा", group: 3, mobile: "9517317286" },
];

export const CELL_TYPES = {
  SK: { label: "SK", labelHi: "स.क.", full: "सत्संग कर्ता" },
  SR: { label: "SR", labelHi: "स.र.", full: "सत्संग रीडर" },
  CD: { label: "CD", labelHi: "सी डी", full: "सी डी सत्संग" },
  LCD: { label: "LCD", labelHi: "सवाल-जवाब", full: "एल सी डी / सवाल-जवाब सत्संग" },
  SPECIAL: { label: "Special SK", labelHi: "विशेष स.क.", full: "विशेष सत्संग कर्ता" },
};

export const WEEKDAYS_HI = ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"];
export const MONTHS_HI = [
  "जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून",
  "जुलाई", "अगस्त", "सितम्बर", "अक्टूबर", "नवम्बर", "दिसम्बर",
];
export const MONTHS_EN = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const byId = (arr) => Object.fromEntries(arr.map((x) => [x.id, x]));
export const GHAR_BY_ID = {};
export const PATHI_BY_ID = {};
export const PREACHER_BY_ID = {};

// Multi-area support: the active area's data is loaded into the arrays/maps in place.
export const DEFAULT_AREA = "palia";
const ACTIVE_KEY = "rssb_active_area";
const AREAS_KEY = "rssb_areas_v1";
const PEOPLE_KEY = "rssb_people_v1"; // legacy (Palia Kalan people only)
const dataKey = (id) => `rssb_area_data_${id}`;
const readJson = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k) || "null");
  } catch {
    return null;
  }
};
export const ACTIVE_AREA = localStorage.getItem(ACTIVE_KEY) || DEFAULT_AREA;
export const isDefaultArea = ACTIVE_AREA === DEFAULT_AREA;
export const getAreas = () => [{ id: DEFAULT_AREA, nameHi: "पलिया कलां" }, ...(readJson(AREAS_KEY) || [])].map((a) =>
  a.id === DEFAULT_AREA ? { ...a, nameHi: readJson(dataKey(DEFAULT_AREA))?.info?.areaHi || a.nameHi } : a
);
export const switchArea = (id) => {
  localStorage.setItem(ACTIVE_KEY, id);
  window.location.reload();
};
export const createArea = (nameHi) => {
  const id = "a" + Date.now().toString(36);
  localStorage.setItem(AREAS_KEY, JSON.stringify([...(readJson(AREAS_KEY) || []), { id, nameHi }]));
  const info = { ...AREA_INFO, areaHi: nameHi, secretaryNameHi: "", secretaryDesignationHi: `एरिया सेक्रेटरी, ${nameHi}`, phones: "", leavePhones: "", infoContactHi: "", timingHi: "" };
  localStorage.setItem(dataKey(id), JSON.stringify({ info, groups: { 1: `${nameHi} क्षेत्र` }, ghars: [], pathis: [], preachers: [] }));
  switchArea(id);
};
export const deleteArea = (id) => {
  if (id === DEFAULT_AREA) return;
  localStorage.setItem(AREAS_KEY, JSON.stringify((readJson(AREAS_KEY) || []).filter((a) => a.id !== id)));
  Object.keys(localStorage).filter((k) => k === dataKey(id) || k.endsWith(`__${id}`)).forEach((k) => localStorage.removeItem(k));
  switchArea(DEFAULT_AREA);
};

const rebuildMaps = () => {
  [[GHAR_BY_ID, GHARS], [PATHI_BY_ID, PATHIS], [PREACHER_BY_ID, PREACHERS]].forEach(([map, arr]) => {
    Object.keys(map).forEach((k) => delete map[k]);
    arr.forEach((x) => (map[x.id] = x));
  });
};
let migrated = false;
// Official satsang place list (as on 24.10.2026): type, MW, secretary, counts
const GHAR_V = 3;
const NO_LCD = ["g3", "g9", "g14", "g20", "g19", "g17", "g23", "g24"];
const m = (type, mw, sec, mob, duty, sk, sr, bsk, pathi, hi) => ({ type, mw, secretaryHi: sec, secretaryMobile: mob, pathiDuty: duty, nSK: sk, nSR: sr, nBSK: bsk, nPathi: pathi, ...(hi ? { hi } : {}) });
const GHAR_META = {
  g1: m("C", "THM", "बलविन्दर सिंह", "9839382249, 9415558477", "0", 1, 3, 0, 8),
  g2: m("SC", "NO", "राम नरेश", "9565623571", "0", 0, 5, 0, 2),
  g3: m("SC", "NO", "एस.बी. सिंह", "9554513601", "0", 0, 1, 0, 2),
  g4: m("SC", "NO", "संत प्रकाश", "9628612312", "0", 0, 1, 0, 3),
  g5: m("SC", "NO", "इन्दरपाल मौर्या", "9918280524", "0", 0, 1, 0, 3),
  g6: m("C", "NO", "सुरेश चौहान", "7054718140", "0", 0, 1, 0, 3),
  g7: m("SC", "NO", "बलविन्दर सिंह", "9721719241", "0", 0, 0, 0, 3),
  g8: m("C", "NO", "भगवंत सिंह", "9628238475", "0", 0, 1, 0, 2),
  g9: m("SP", "NO", "राम कुमार", "8737098908", "0", 0, 0, 0, 1),
  g10: m("C", "NO", "गुरनाम सिंह", "7268816557", "0", 0, 0, 0, 5),
  g11: m("SP", "NO", "राम आसरे", "8127824819", "0", 0, 0, 0, 2),
  g12: m("C", "NO", "अमृतपाल सिंह", "9839338749", "0", 1, 1, 0, 1),
  g13: m("SC", "THM", "सभापति राना", "6393108005", "0", 1, 3, 0, 7),
  g14: m("SC", "NO", "कमलेश वर्मा", "9838034526", "0", 0, 1, 0, 2),
  g15: m("SC", "NO", "दया शंकर", "9559119951", "0", 0, 0, 0, 1),
  g16: m("C", "NO", "वरिनदर सिंह बराड़", "6394034547", "0", 0, 1, 0, 1),
  g17: m("SP", "NO", "गुरसहाय श्रीवास्तव", "9452194208", "", 0, 1, 0, 0),
  g18: m("SC", "NO", "रवि कुमार", "7755800124", "0", 0, 2, 0, 0),
  g19: m("SP", "NO", "हरिराम मौर्या", "9473977492", "0", 0, 1, 0, 0),
  g20: m("SC", "NO", "सुबेदार", "7408715853", "0", 0, 0, 0, 3, "छपरिया बाजार"),
  g21: m("C", "WM", "छेदू राम", "9335897220", "0", 0, 3, 0, 7),
  g22: m("SC", "THM", "राम भजन", "7839189884", "0", 0, 1, 0, 8),
  g23: m("SC", "NO", "रामचरन", "7839004590", "0", 6, 2, 0, 3, "देवराही"),
  g24: m("SC", "NO", "संतरी", "8887069584", "0", 0, 2, 0, 3),
  g25: m("C", "NO", "प्रेम सिंह", "9456418139", "0", 0, 2, 0, 2),
};
if (isDefaultArea) GHARS.forEach((g) => Object.assign(g, GHAR_META[g.id], NO_LCD.includes(g.id) ? { noLcd: true } : {}));
const saved = readJson(dataKey(ACTIVE_AREA)) || (isDefaultArea ? readJson(PEOPLE_KEY) : null);
if (saved) {
  if (saved.info) Object.assign(AREA_INFO, saved.info);
  if (saved.groups) {
    Object.keys(GROUPS).forEach((k) => delete GROUPS[k]);
    Object.assign(GROUPS, saved.groups);
  }
  if (saved.ghars) GHARS.splice(0, GHARS.length, ...saved.ghars);
  if (isDefaultArea && saved.ghars && saved.gharV !== GHAR_V) {
    if (saved.gharV !== 2) GHARS.forEach((g) => GHAR_META[g.id] && Object.assign(g, GHAR_META[g.id]));
    GHARS.forEach((g) => NO_LCD.includes(g.id) && (g.noLcd = true));
    migrated = true;
  }
  if (saved.pathis) PATHIS.splice(0, PATHIS.length, ...saved.pathis);
  if (saved.preachers) PREACHERS.splice(0, PREACHERS.length, ...saved.preachers);
  // Sita Devi (Bheera) is a satsang reader, not a pathi
  const sita = PATHIS.findIndex((p) => p.id === "p20");
  if (isDefaultArea && sita >= 0) {
    const p = PATHIS.splice(sita, 1)[0];
    if (!PREACHERS.some((x) => x.id === "s33")) PREACHERS.push({ ...p, id: "s33", role: "SR", title: p.title ?? "श्रीमती" });
    migrated = true;
  }
} else if (!isDefaultArea) {
  GHARS.length = PATHIS.length = PREACHERS.length = 0;
}
rebuildMaps();
if (migrated) setTimeout(() => persistArea(), 0);

const persistArea = () => {
  localStorage.setItem(
    dataKey(ACTIVE_AREA),
    JSON.stringify({ info: AREA_INFO, groups: GROUPS, ghars: GHARS, gharV: GHAR_V, pathis: PATHIS, preachers: PREACHERS })
  );
  if (!isDefaultArea) {
    const list = (readJson(AREAS_KEY) || []).map((a) => (a.id === ACTIVE_AREA ? { ...a, nameHi: AREA_INFO.areaHi } : a));
    localStorage.setItem(AREAS_KEY, JSON.stringify(list));
  }
};
export const savePeople = (kind, list) => {
  const arr = kind === "pathi" ? PATHIS : PREACHERS;
  arr.splice(0, arr.length, ...list);
  rebuildMaps();
  persistArea();
};
export const saveGhars = (list) => {
  GHARS.splice(0, GHARS.length, ...list);
  rebuildMaps();
  persistArea();
};
export const saveAreaInfo = (info) => {
  Object.assign(AREA_INFO, info);
  persistArea();
};

export const TITLES = ["श्री", "श्रीमती", "कुमारी"];
export const splitTitle = (name) => {
  const m = String(name || "").trim().match(/^(श्रीमती|कुमारी|सुश्री|श्री)\s+(.*)$/);
  return m ? { title: m[1], rest: m[2] } : { title: "", rest: String(name || "").trim() };
};
export const applyTitle = (title, name) => {
  const rest = splitTitle(name).rest;
  return rest && title ? `${title} ${rest}` : rest;
};

// Ghar type labels in Hindi (official area style): C = स, SC = स.स., SP = स.प.
export const GHAR_TYPE_HI = { C: "स", SC: "स.स.", SP: "स.प." };

// Gender map for honorifics (श्री / श्रीमती) shown with names in grid & all exports
export const GENDER = {
  p1: "M", p2: "F", p3: "M", p4: "F", p5: "M", p6: "M", p7: "M", p8: "M", p9: "F", p10: "F",
  p11: "M", p12: "M", p13: "F", p14: "F", p15: "M", p16: "M", p17: "M", p18: "F", p19: "F", p20: "F",
  p21: "F", p22: "F", p23: "M", p24: "F", p25: "M", p26: "F", p27: "F", p28: "M", p29: "M", p30: "F",
  p31: "M", p32: "M", p33: "F", p34: "F", p35: "F", p36: "M", p37: "F", p38: "M", p39: "M", p40: "M",
  p41: "M", p42: "F", p43: "M", p44: "M", p45: "M", p46: "M", p47: "M", p48: "F", p49: "F", p50: "F",
  p51: "M", p52: "F", p53: "F", p54: "M", p55: "F", p56: "M", p57: "M", p58: "F", p59: "M", p60: "F",
  p61: "M", p62: "M",
  s1: "M", s2: "F", s3: "F", s4: "M", s5: "M", s6: "M", s7: "M", s8: "M", s9: "M", s10: "F",
  s11: "M", s12: "M", s13: "M", s14: "M", s15: "M", s16: "M", s17: "M", s18: "M", s19: "M", s20: "F",
  s21: "M", s22: "M", s23: "F", s24: "F", s25: "M", s26: "M", s27: "M", s28: "M", s29: "M", s30: "M",
  s31: "M", s32: "M",
};
// Name with honorific prefix (custom/free-text names are returned as-is;
// names already starting with श्री like श्रीपाल/श्रीकृष्ण are not double-prefixed)
export const withHonorific = (p) => {
  if (!p) return "";
  const t = personTitle(p);
  if (!t) return p.hi;
  if (t === "श्री" && p.hi.startsWith("श्री")) return p.hi;
  return `${t} ${p.hi}`;
};
export const personTitle = (p) => {
  if (p.title !== undefined) return p.title;
  const g = GENDER[p.id];
  return g === "F" ? "श्रीमती" : g === "M" ? "श्री" : "";
};

// Resolve display names, honoring free-text custom entries + optional (locality, mobile).
const brk = (city, mobile, base = "") => {
  const c = (city || "").trim();
  const parts = [base.includes(`(${c})`) ? "" : c, mobile].map((x) => (x || "").trim()).filter(Boolean);
  return parts.length ? ` (${parts.join(", ")})` : "";
};
export const resolvePreacherHi = (c) => {
  if (!c) return "";
  const p = c.preacherId ? PREACHER_BY_ID[c.preacherId] : null;
  const base = c.customPreacher || withHonorific(p) || "";
  if (!base) return "";
  const city = (c.preacherCity || "").trim() || p?.placeHi || "";
  return base + brk(city, c.preacherMobile || p?.mobile, base);
};
export const resolvePreacherEn = (c) => {
  if (!c) return "";
  const p = c.preacherId ? PREACHER_BY_ID[c.preacherId] : null;
  const base = c.customPreacher || p?.en || "";
  if (!base) return "";
  const city = (c.preacherCity || "").trim() || p?.placeHi || "";
  return base + brk(city, c.preacherMobile || p?.mobile);
};
export const resolvePathiHi = (c) => {
  if (!c) return "";
  const p = c.pathiId ? PATHI_BY_ID[c.pathiId] : null;
  const base = c.customPathi || withHonorific(p) || "";
  if (!base) return "";
  const city = (c.pathiCity || "").trim() || p?.placeHi || "";
  return base + brk(city, c.pathiMobile || p?.mobile, base);
};
export const resolvePathiEn = (c) => {
  if (!c) return "";
  const p = c.pathiId ? PATHI_BY_ID[c.pathiId] : null;
  const base = c.customPathi || p?.en || "";
  if (!base) return "";
  const city = (c.pathiCity || "").trim() || p?.placeHi || "";
  return base + brk(city, c.pathiMobile || p?.mobile);
};
export const SLOT_HI = { morning: "सुबह", noon: "दोपहर" };

// Season-wise satsang timings (per area). Months 0-11; summer months use the summer set.
const TIMING_KEY = `rssb_timings_v1${isDefaultArea ? "" : `__${ACTIVE_AREA}`}`;
export const DEFAULT_TIMINGS = {
  summerMonths: [2, 3, 4, 5, 6, 7, 8],
  summer: { sun: "09:30", wed: "08:30", thu: "08:30", noon: "13:00" },
  winter: { sun: "09:30", wed: "08:30", thu: "08:30", noon: "13:00" },
};
export const getTimings = () => ({ ...DEFAULT_TIMINGS, ...(readJson(TIMING_KEY) || {}) });
export const saveTimings = (t) => localStorage.setItem(TIMING_KEY, JSON.stringify(t));
export const fmt12 = (hm) => {
  const [h, m] = String(hm || "").split(":").map(Number);
  if (Number.isNaN(h)) return "";
  return `${((h + 11) % 12) + 1}:${String(m || 0).padStart(2, "0")}${h >= 12 ? "pm" : "am"}`;
};
const dowOf = (iso) => new Date(`${iso}T00:00:00Z`).getUTCDay();
// Season default as "HH:MM".
export const defaultHM = (iso, slot = "morning", dow = dowOf(iso)) => {
  const t = getTimings();
  const s = t.summerMonths.includes(Number(iso.split("-")[1]) - 1) ? t.summer : t.winter;
  return slot === "noon" ? s.noon : dow === 0 ? s.sun : dow === 3 ? s.wed : s.thu;
};
export const satsangTime = (iso, dow = dowOf(iso), slot = "morning") => fmt12(defaultHM(iso, slot, dow));
// A satsang's own time: edited time if set, else the season default.
export const cellTime = (cell, iso) => (iso ? fmt12(cell?.time || defaultHM(iso, cell?.special?.slot)) : "");

export const resolveSpecialHi = (c, iso, withTime = true) => {
  const base = c?.special?.name || "";
  if (!base) return "";
  const time = withTime ? cellTime(c, iso) : "";
  return base + (time ? ` – ${time}` : "") + brk(c?.special?.fromCity, c?.special?.mobile);
};

// Footer note lines used by PDFs and slips.
export const noteLines = (month) =>
  [
    "सभी इंचार्जों से विनती है कि बाहर से आने वाले सत्संग कर्ता, रीडर एवं पाठियों के ठहरने तथा हेल्पलाइन संबंधी जानकारी उन्हें अवश्य दे दें।",
    AREA_INFO.leavePhones &&
      `जिस किसी सेवादार को ${MONTHS_HI[(month + 1) % 12]} माह में छुट्टी चाहिए वह दिनांक 10 ${MONTHS_HI[month]} तक ${AREA_INFO.leavePhones} मोबाइल नंबर पर सूचित करें।`,
    AREA_INFO.infoContactHi && `अधिक जानकारी के लिए ${AREA_INFO.infoContactHi} मोबाइल नंबर पर संपर्क करें जी।`,
  ].filter(Boolean);
